var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerSquareArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 122 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-626.000000, -597.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(402.000000, 378.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(224.000000, 217.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "7.531753e-13 1.84741111e-13 7.531753e-13 119 7.531753e-13 120 1 120 111.887 120 111.887 120.391 111.887 127.292 121.686 119.692 121.087 119.191 120.287 118.591 111.887 111.992 111.887 118.591 111.887 119 1 119 1 1.84741111e-13"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerSquareArrowLeft);
export default __webpack_public_path__ + "static/media/corner-square-arrow-left.97a8a7c3cfdb674a1fa6d15023531b38.svg";
export { ForwardRef as ReactComponent };